var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOfDavid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C12.2634 1.25 12.5076 1.38822 12.6431 1.61413L15.4246 6.25H21C21.2702 6.25 21.5195 6.39534 21.6527 6.63048C21.7858 6.86561 21.7821 7.15417 21.6431 7.38587L18.8746 12L21.6431 16.6141C21.7821 16.8458 21.7858 17.1344 21.6527 17.3695C21.5195 17.6047 21.2702 17.75 21 17.75H15.4246L12.6431 22.3859C12.5076 22.6118 12.2634 22.75 12 22.75C11.7366 22.75 11.4924 22.6118 11.3569 22.3859L8.57536 17.75H3C2.7298 17.75 2.48048 17.6047 2.34735 17.3695C2.21422 17.1344 2.21786 16.8458 2.35688 16.6141L5.12536 12L2.35688 7.38587C2.21786 7.15417 2.21422 6.86561 2.34735 6.63048C2.48048 6.39534 2.7298 6.25 3 6.25H8.57536L11.3569 1.61413C11.4924 1.38822 11.7366 1.25 12 1.25ZM7.67536 7.75H4.32464L6 10.5423L7.67536 7.75ZM6.87464 12L9.42464 16.25H14.5754L17.1254 12L14.5754 7.75H9.42464L6.87464 12ZM6 13.4577L4.32464 16.25H7.67536L6 13.4577ZM10.3246 17.75L12 20.5423L13.6754 17.75H10.3246ZM16.3246 16.25H19.6754L18 13.4577L16.3246 16.25ZM18 10.5423L19.6754 7.75H16.3246L18 10.5423ZM13.6754 6.25L12 3.45774L10.3246 6.25H13.6754Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOfDavid);
export default __webpack_public_path__ + "static/media/star-of-david.d7d52e91c83955231d034e2b538609c8.svg";
export { ForwardRef as ReactComponent };